module.exports = __webpack_public_path__ + "cancellara-dist/img/jakala.061b8fd8.png";